export default "__VITE_ASSET__D7cCgRrm__"